import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '../../ClickAndReserve/context/ClickAndReserveGlobalContext/ClickAndReserveGlobalContext.js';
import '@grandvisionhq/common';
import '@grandvisionhq/stores-v2';
import '../../../types/product.js';
import '@swc/helpers';
import '@grandvisionhq/analytics';
import '@grandvisionhq/iris-ui';
import ClickAndReserveContainer from '../../ClickAndReserve/components/ClickAndReserveContainer.js';
import '@grandvisionhq/forms';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import { MultiFacetPicker } from '../components/FacetPickerContainers/MultiFacetPicker/MultiFacetPicker.js';
import { useEcommFacetContext } from '../context/EcommFacetContext.js';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import { ProductReimbursableLogoContainer } from '../components/ProductReimbursableLogo/ProductReimbursableLogoContainer.js';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import '@grandvisionhq/content';
import { FramesBundleContentDescriptionContainer } from './components/FramesBundleContentDescription/FramesBundleContentDescriptionContainer.js';
import { FramesCTA } from './components/FramesCTA/FramesCTA.js';
import { FramesDeliveryIndicator } from './components/FramesDeliveryIndicator/FramesDeliveryIndicator.js';
import { useFramesEcommContext } from './context/FramesEcommContext.js';
import { FramesPriceSection } from './components/FramesPriceSection/FramesPriceSection.js';
import { FramesOfferingsList } from './components/FramesOfferingsList/FramesOfferingsList.js';

const FramesEcommContent = ({ className , ctaRef  })=>{
    const { activeVariant: { displayName , sku: activeSku  } ,  } = useProductData();
    const { handleConfiguratorClose , isConfiguratorOpen  } = useFramesEcommContext();
    const { isValid , setNotificationType  } = useEcommFacetContext();
    const triggerAlertMessage = ()=>setNotificationType('error')
    ;
    const { isPrescriptionGlassesEnabled  } = useFeatureToggles();
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('frames-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductReimbursableLogoContainer, {
        className: "frames-ecomm-content__reimbursable-logo"
    }), /*#__PURE__*/ React.createElement(ProductTag, {
        className: "frames-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(FramesBundleContentDescriptionContainer, null), /*#__PURE__*/ React.createElement(FramesPriceSection, null), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(MultiFacetPicker, {
        showStockIndicator: isPrescriptionGlassesEnabled
    }), /*#__PURE__*/ React.createElement("div", {
        className: "frames-ecomm-content__column"
    }, /*#__PURE__*/ React.createElement(FramesOfferingsList, null), /*#__PURE__*/ React.createElement(FramesDeliveryIndicator, null), /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(FramesCTA, null)), /*#__PURE__*/ React.createElement(ClickAndReserveContainer, {
        sku: activeSku,
        onInvalidClick: !isValid ? triggerAlertMessage : undefined
    }), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), Slots.Configurator && /*#__PURE__*/ React.createElement(Slots.Configurator, {
        id: "glasses",
        onModalClose: handleConfiguratorClose,
        isOpen: isConfiguratorOpen
    }));
};

export { FramesEcommContent };
//# sourceMappingURL=FramesEcommContent.js.map
